module.exports = {
      id: "view-usage",
      viewBox: "0 0 21 13",
      url: "img/" + "sprite.svg#view-usage",
      toString: function () {
        return this.url;
      }
    }